import CreateFamilyAccountContext, {
    CreateFamilyAccountProvider,
    ECreateFamilyAccountUiState,
    TFirstPartyUser,
} from '../../contexts/CreateFamilyAccountContext';
import PageLayout from '../../layout/PageLayout/PageLayout';
import { ERoutes } from '../../util/constants';
import { Route, Switch, Redirect } from 'react-router';
import ConfirmFamilyAccount from '../../components/ConfirmFamilyAccount/ConfirmFamilyAccount';
import CreateFamilyAccountForm from '../../components/CreateFamilyAccountForm/CreateFamilyAccountForm';
import CreateAccountSuccess from '../../components/CreateAccountSuccess/CreateAccountSuccess';
import { TCreateAccountPickerRouterState } from '../../components/CreateAccountPicker/CreateAccountPicker';
import CreateFamilyAccountLinkUser from '../../components/CreateFamilyAccountLinkUser/CreateFamilyAccountLinkUser';
import Card from '../../components/Card/Card';
import { FC, ReactElement, useContext } from 'react';

const CreateFamilyAccountRouter: FC = () => {
    const { primaryUser, submitVerifyPasscode, resendVerifyPasscode } = useContext(CreateFamilyAccountContext);
    const firstPartyUser = primaryUser as TFirstPartyUser;
    return (
        <Switch>
            <Route exact path={ERoutes.createFamilyAccount}>
                <CreateFamilyAccountForm />
            </Route>
            <Route path={ERoutes.createFamilyAccountManualLinkUser}>
                <PageLayout showHeader={false}>
                    <CreateFamilyAccountLinkUser />
                </PageLayout>
            </Route>
            <Route path={ERoutes.createFamilyAccountConfirm}>
                <ConfirmFamilyAccount />
            </Route>
            <Route path={ERoutes.createFamilyAccountSuccess}>
                <CreateAccountSuccess
                    email={firstPartyUser.email}
                    onVerifyPasscode={submitVerifyPasscode}
                    onResendPasscode={resendVerifyPasscode}
                />
            </Route>
        </Switch>
    );
};

const CreateFamilyAccountUi: FC = () => {
    const { createFamilyAccountUiState, redirectUrl, errorMessage, primaryUser, linkingToken } =
        useContext(CreateFamilyAccountContext);
    let createFamilyAccountUi: ReactElement;
    switch (createFamilyAccountUiState) {
        case ECreateFamilyAccountUiState.default:
            createFamilyAccountUi = <Card />;
            break;
        case ECreateFamilyAccountUiState.ready:
            createFamilyAccountUi = <CreateFamilyAccountRouter />;
            break;
        case ECreateFamilyAccountUiState.firstPartySuccess:
        case ECreateFamilyAccountUiState.migrationSuccess:
            createFamilyAccountUi = (
                <>
                    <Redirect to={ERoutes.createFamilyAccountSuccess} />
                    <CreateFamilyAccountRouter />
                </>
            );
            break;
        case ECreateFamilyAccountUiState.thirdPartySuccess:
            createFamilyAccountUi = <>{window.location.assign(redirectUrl)}</>;
            break;
        case ECreateFamilyAccountUiState.confirmAccountSuccess:
            createFamilyAccountUi = null;
            break;
        case ECreateFamilyAccountUiState.error:
            const createAccountRouterState: TCreateAccountPickerRouterState = { errorMessage };
            createFamilyAccountUi = (
                <Redirect to={{ pathname: ERoutes.createAccount, state: createAccountRouterState }} />
            );
            break;
        case ECreateFamilyAccountUiState.notInitialized:
            createFamilyAccountUi = <Redirect to={ERoutes.login} />;
            break;
        default:
            throw Error('Create Family Account Ui State Set Incorrectly');
    }
    return createFamilyAccountUi;
};

const CreateFamilyAccountScreen: FC = () => {
    return (
        <CreateFamilyAccountProvider>
            <CreateFamilyAccountUi />
        </CreateFamilyAccountProvider>
    );
};

export default CreateFamilyAccountScreen;
